module.exports = __webpack_public_path__ + "img/share.9df7361f.svg";